import React, { useState, useEffect } from 'react';
import { FileUploader } from 'devextreme-react/file-uploader';
import { Grid, GridColumn, Icon, Segment } from 'semantic-ui-react';
import { BASE_URL_UPLOAD } from '../../api';

const VideoUploader = ({ data, Url }) => {
    const uploadUrl = Url ? `${BASE_URL_UPLOAD}${Url}` : `${BASE_URL_UPLOAD}/video/upload`;
    const [loading, setLoading] = useState(false);
    const allowedFileExtensions = ['.mp4'];

    useEffect(() => {
        let open = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function () {
            open.apply(this, arguments);
            this.withCredentials = true;
        };
    }, []);

    const onUploaded = (e) => {
        const file = e.file;
        const fileReader = new FileReader();
        fileReader.onload = () => {
            setLoading(false);
        };
        fileReader.readAsDataURL(file);

        const response = JSON.parse(e.request.response);
        if (data.topicId)
            data.setValue({ urlEn: response.videoUrl, sizeInBytesEn: response.sizeInBytes, lengthSecondsEn: response.lengthSec, topicId: data.topicId });
        if (data.questionId)
            data.setValue({ urlEn: response.videoUrl, sizeInBytesEn: response.sizeInBytes, lengthSecondsEn: response.lengthSec, questionId: data.questionId });
        if (data.isExamDemo)
            data.setValue({ urlEn: response.videoUrl, sizeInBytesEn: response.sizeInBytes, lengthSecondsEn: response.lengthSec, });
        if (data.isGeneral)
            data.setValue({ urlEn: response.videoUrl, sizeInBytesEn: response.sizeInBytes, lengthSecondsEn: response.lengthSec, accessTerm: 'PUBLIC' });
    };

    return (
        <div>
            <Grid stackable columns={2}>
                <GridColumn textAlign='center' verticalAlign='middle'>
                    <FileUploader
                        id="file-uploader"
                        multiple={false}
                        accept="video/mp4"
                        allowedFileExtensions={allowedFileExtensions}
                        uploadMode="instantly"
                        uploadUrl={uploadUrl}
                        visible
                        disabled={!data.topicId && !data.questionId && !data.isExamDemo && !data.isGeneral}
                        allowCanceling
                        name='video'
                        // onUploadStarted={() => setLoading(true)}
                        onUploaded={onUploaded}
                    // onUploadAborted={() => setLoading(false)}
                    // onUploadError={() => setLoading(false)}
                    />
                </GridColumn>

                <GridColumn textAlign='center'>
                    {
                        loading ? <Segment size='huge' basic placeholder loading /> :
                            data?.value ? <Icon name='video play' circular size='huge' /> :
                                <Icon name='upload' circular size='huge' />
                    }
                </GridColumn>
            </Grid>
        </div>
    );
};



export default VideoUploader;